module.exports = __webpack_public_path__ + "img/111.77d7411c.jpg";